export default __webpack_public_path__ + "assets/icons/message-from-bob-icon.60b7e65fe77dd2a9725874f42b335c03.svg";